import _ from 'lodash';
import { API_CREATE_CLIENT_OFFER_DETAIL_VIEW_EVENT, API_CREATE_CLIENT_OFFER_VIEW_EVENT, API_GET_ONE_CLIENT_RFP_SUCCESS, API_UPDATE_CLIENT_OFFER_APPROACH, } from '../actions/ClientRfpActions';
import { RFP_EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT, RFP_EVENT_TYPE_CLIENT_OFFER_VIEW, RFP_EVENT_TYPE_CLIENT_RFP_VIEW, } from '../define/consts/rfp/rfp_event';
const initialState = {
    one: {},
};
const getNewRfp = (state, meta, updateRfp) => {
    const { id } = meta;
    return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [id]: Object.assign(Object.assign({}, state.one[id]), updateRfp) }) });
};
const getNewOffer = (state, meta, updateOffer) => {
    const { rfpId, viewRequestId } = meta;
    const numViewRequestId = parseInt(viewRequestId, 10);
    const rfp = state.one[rfpId];
    const viewRequestIndex = rfp.view_requests.findIndex((v) => v.id === numViewRequestId);
    const viewRequest = _.get(state, `one.${rfpId}.viewRequests.${viewRequestIndex}`);
    if (viewRequest) {
        viewRequest.offer = Object.assign(Object.assign({}, viewRequest.offer), updateOffer);
    }
    return state;
};
// eslint-disable-next-line default-param-last
export default (state = initialState, { meta, payload, type }) => {
    switch (type) {
        case API_GET_ONE_CLIENT_RFP_SUCCESS: {
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [payload.id]: payload }) });
        }
        case API_CREATE_CLIENT_OFFER_VIEW_EVENT: {
            const { data: { event }, } = payload;
            if (event === RFP_EVENT_TYPE_CLIENT_RFP_VIEW) {
                return getNewRfp(state, meta, { isInterviewView: true });
            }
            if (event === RFP_EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT) {
                return getNewRfp(state, meta, { isShowWarnCharmPoint: true });
            }
            return state;
        }
        case API_UPDATE_CLIENT_OFFER_APPROACH: {
            const { data: { charmPoint }, } = payload;
            return getNewOffer(state, meta, { charm_point: charmPoint });
        }
        case API_CREATE_CLIENT_OFFER_DETAIL_VIEW_EVENT: {
            const { data: { event }, } = payload;
            if (event === RFP_EVENT_TYPE_CLIENT_OFFER_VIEW) {
                return getNewOffer(state, meta, { is_view: true });
            }
            return state;
        }
        default: {
            return state;
        }
    }
};
